// extracted by mini-css-extract-plugin
module.exports = {"footer":"welcomeFooter_footer__mRZGz"};